<template>
  <div class="concent" style="background-color: #f0f0f0">


    <div style="height: 104px;background: rgba(255,255,255,0.5);border-radius: 0px 0px 0px 0px;position:absolute;padding:12px 345px;width: 100%">

      <img style="width: 236px;height:80px" :src="u.config().static+'/'+system.logback">

    </div>

    <div style="height: 812px;background-color: #F6F9FF">
      <div style="width: 75%;height: 720px" class="homeindex">
        <div class="ovbacks" style="width: 38%">
          <!--          占位-->
          <div style="height: 318px"></div>
          <div style="color: #3A3551;font-size: 35px;letter-spacing: 6px;"> {{ system.logindesc }}</div>
          <div style="height: 20px"></div>
          <div style="color: #0F244D;font-size: 60px;font-weight: bold;">{{ system.indextitlemax }}</div>
          <div style="height: 20px"></div>
          <div style="display: flex;justify-content: space-between;font-weight: bold;font-size: 22px;letter-spacing: 21px;color: #0F244D;">
            <div>{{ system.homeTitle }}</div>
            <div>{{ system.homeDesc }}</div>
          </div>
          <div style="height: 174px"></div>
          <div style="font-weight: 500;font-size: 20px;color: #2593FB;">官方平台</div>
          <div style="height: 10px"></div>
          <div style="width: 43px;height: 3px;background: #1190FF;border-radius: 8px;"></div>
        </div>
        <div class="ovbacks" style="width: 62%">

          <div style="height: 222px">
          </div>
          <div style="width: 369px;height:415px ;background: #FFFFFF;border-radius: 8px;float: right;margin-right: 23px;padding:40px">
            <div style="height: 30px;text-align: right ;color:#1190FF;cursor:pointer;" v-if="logintype==1" @click="logintype=2">
              密码登录
            </div>
            <div style="height: 30px;text-align: right ;color:#1190FF;cursor:pointer;" v-else @click="logintype=1">
              验证码登录
            </div>
            <div style="color: #000000;font-size: 26px;font-weight: bold;letter-spacing: 2px;">手机验证码登录</div>
            <div style="height: 25px"></div>
            <div style="font-size: 15px;color: #999999;letter-spacing: 1px;">验证手机号立即登录</div>
            <div style="height: 36px"></div>
            <div>
              <el-input v-model="loginform.phone" clearable maxlength="11" placeholder="请输入手机号" class="inputk" style="width:100%;"></el-input>
              <div style="height: 20px"></div>
            </div>

            <div v-if="logintype==2">
              <el-input v-model="loginform.pwd" type="password" clearable placeholder="请输入密码" class="inputk" style="width:100%;"></el-input>
            </div>

            <div style="display: flex" v-else>
              <div style="width: 100%">
                <el-input v-model="loginform.code" placeholder="请输入验证码" maxlength="6" class="inputk"></el-input>
              </div>
              <div
                style="color:#1190FF;text-align: right;width: 0%;cursor: pointer;position: relative;right: 85px;top:11px;white-space:nowrap;font-size: 14px;"
                @click="get_code()">
                {{ codemsg }}
              </div>
            </div>

            <div style="height: 60px"></div>

            <div style="text-align: center;">
              <el-button
                style="width: 319px;height: 40px;background: linear-gradient( 90deg, #10A7FF 0%, #1190FF 100%);border-radius: 8px;color: #FFFFFF"
                @click="login"> 立 即 登 录
              </el-button>
            </div>

            <div style="height: 36px"></div>

            <div style="text-align: center;color: #B4B4B4; ">
              <el-checkbox v-model="checked"></el-checkbox>
              已阅读并同意 <span class="xieyi" @click="navrto(system.yonghuxieyi)">用户协议</span> 和 <span class="xieyi" @click="navrto(system.yingsizhengce)">隐私条款</span>
            </div>

          </div>

        </div>
      </div>

    </div>

    <div style="height: 576px;display: flex;">

      <div style="color: #333333;height: 100%;padding-left: 331px;font-size: 50px;letter-spacing: 7px;font-weight: bold;">
        <div style="height: 193px;   white-space:nowrap;"></div>
        <div style=" white-space:nowrap;">引领本地生活</div>
        <div style=" white-space:nowrap;">AI智能化运营</div>
      </div>
      <div style="padding-left: 86px">

        <div style="height: 108px"></div>


        <el-tabs v-model="activeName" @tab-click="handleClick" :tab-position="'bottom'">
          <el-tab-pane label="小时达" name="first">
            <div style="height: 288px;width: 793px;background-color: #FFFFFF;display: flex;border-radius: 8px">

              <div style="width: calc(100% - 470px);padding:50px">
                <div style="font-size: 32px;color: #3A3551;">万亿即时零售市场</div>
                <div style="color: #999999;line-height: 23px;letter-spacing: 4px;font-size: 20px;">
                  <div style="height: 23px"></div>
                  <div>小时达服务通常指消费者在下</div>
                  <div style="height: 23px"></div>
                  <div>单后，商家在约定的一小时内</div>
                  <div style="height: 23px"></div>
                  <div>将商品送达消费者手中</div>
                </div>

              </div>
              <div style="width: 370px;height: 288px;">
                <img style="width: 100%;height: 100%" src="https://file.sumou.fun/homeadmin/image/tab-1.png">
              </div>

            </div>

          </el-tab-pane>
          <el-tab-pane label="流量涡轮" name="second">

            <div style="height: 288px;width: 793px;background-color: #FFFFFF;display: flex;border-radius: 8px">

              <div style="width: calc(100% - 470px);padding:50px">
                <div style="font-size: 32px;color: #3A3551;">电商直播流量涡轮包</div>
                <div style="color: #999999;line-height: 23px;letter-spacing: 4px;font-size: 20px;">
                  <div style="height: 23px"></div>
                  <div>短时间内将商家发布的行</div>
                  <div style="height: 23px"></div>
                  <div>业相关短视频直接推送至</div>
                  <div style="height: 23px"></div>
                  <div>5000+精准播放流量</div>
                </div>

              </div>
              <div style="width: 370px;height: 288px;">
                <img style="width: 100%;height: 100%" src="https://file.sumou.fun/homeadmin/image/tab-2.png">
              </div>

            </div>
          </el-tab-pane>


          <el-tab-pane label="全域抖音外卖" name="third">

            <div style="height: 288px;width: 793px;background-color: #FFFFFF;display: flex;border-radius: 8px">

              <div style="width: calc(100% - 470px);padding:50px">
                <div style="font-size: 32px;color: #3A3551;">全域外卖运营服务</div>
                <div style="color: #999999;line-height: 23px;letter-spacing: 4px;font-size: 20px;">
                  <div style="height: 23px"></div>
                  <div>为本地生活的商家开通外卖入</div>
                  <div style="height: 23px"></div>
                  <div>口并搭配Al无人直播工具赋能</div>
                  <div style="height: 23px"></div>
                  <div>商家让商家的订单通过抖音井</div>
                  <div style="height: 23px"></div>
                  <div>喷式增长 !</div>
                </div>

              </div>
              <div style="width: 370px;height: 288px;">
                <img style="width: 100%;height: 100%" src="https://file.sumou.fun/homeadmin/image/tab-3.png">
              </div>

            </div>
          </el-tab-pane>
          <el-tab-pane label="SAAS系统" name="fourth">


            <div style="height: 288px;width: 793px;background-color: #FFFFFF;display: flex;border-radius: 8px">

              <div style="width: calc(100% - 470px);padding:50px">
                <div style="font-size: 32px;color: #3A3551;">SAAS门店管理系统</div>
                <div style="color: #999999;line-height: 23px;letter-spacing: 4px;font-size: 20px;">
                  <div style="height: 23px"></div>
                  <div>在智能时代的深度应用聚焦</div>
                  <div style="height: 23px"></div>
                  <div>高科技板块·实现企业商家</div>
                  <div style="height: 23px"></div>
                  <div>的降本增效全面资金管挥</div>
                </div>

              </div>
              <div style="width: 370px;height: 288px;">
                <img style="width: 100%;height: 100%" src="https://file.sumou.fun/homeadmin/image/tab-1.png">
              </div>

            </div>
          </el-tab-pane>
        </el-tabs>


      </div>


    </div>

    <div style="text-align: center;white-space:nowrap;">

      <span class="descname">{{ system.minsystemName }}</span>
      <span style="font-size: 50px;letter-spacing: 7px;color: #333333;font-weight: 800;white-space:nowrap;">cps.pos已接入平台</span>
    </div>
    <div style="height: 80px">

    </div>
    <div style="text-align: center;">
      <img style="width: 1227px" src="https://file.sumou.fun/homeadmin/image/shouqianzixun.png">
    </div>


    <div style="height: 453px;display: flex" class="shouqian">

      <div>
        <img style="margin-left: 229px;margin-top: 75px" src="https://file.sumou.fun/homeadmin/image/shouqianiconfont.png">
      </div>
      <div style="margin-left: 127px">

        <div style="height: 106px"></div>
        <div style="font-weight: bold;font-size: 50px;letter-spacing: 11px;color: #FFFFFF;">售前咨询</div>
        <div style="height: 60px"></div>
        <div style="font-weight: bold;font-size: 32px;letter-spacing: 7px;color: #FFFFFF;">现在联系，获取一对-支付解决方案，专业顾问为您解答!</div>
        <div style="height: 60px"></div>
        <div style="font-weight: bold;font-size: 32px;letter-spacing: 7px;color: #FFFFFF;white-space:nowrap;">客户经理 <span
          style="margin-left: 35px">{{ system.phonenumber }}</span></div>
      </div>

    </div>


    <div style="height: 150px"></div>

    <div style="padding :0 330px">

      <div style="color: #333333;letter-spacing: 7px;font-weight: bold;font-size: 50px;white-space:nowrap;">常见问题</div>

    </div>
    <div style="height: 57px"></div>

    <div style="display: flex;justify-content: space-between;padding:0 325px">

      <div style="background-color: #FFFFFF;padding:25px;width:385px;height: 186px;background-color: #FFFFFF;border-radius: 8px ">

        <div style="font-size: 20px;color: #000000;letter-spacing: 4px;white-space:nowrap;">用平台对账有什么好处？</div>
        <div style="height: 25px"></div>
        <div style="font-size: 14px;color: #999999;letter-spacing: 3px;overflow: hidden">
          帮助企业实现资金监测与预测。财务数据实时生
          成，企业可实时捕捉费用开支详细数据，并自动
          生成多维度、可视化的财务分析和交易分析报告
          ，按需细化管理颗粒度，让企业管理者实时全面
          了解成本支出情况，助力挖掘新的成本降低机会
          ，从而提高企业整体盈利能力。

        </div>
      </div>

      <div style="background-color: #FFFFFF;padding:25px;width:385px;margin-left:20px;height: 186px;background-color: #FFFFFF;border-radius: 8px ">

        <div style="font-size: 20px;color: #000000;letter-spacing: 4px;white-space:nowrap;">用商家管理有什么好处？</div>
        <div style="height: 25px"></div>
        <div style="font-size: 14px;letter-spacing: 3px;color: #999999;">
          一款面向生产制造企业、品牌总代，各类商贸B
          2B批发企业的网上订货系统，灵活满足总公司与
          分公司，直营店，连锁门店，分销商，大客户的
          订货业务需求，有效提升企业销售业绩。

        </div>
      </div>

      <div style="background-color: #FFFFFF;padding:25px;width:385px;margin-left:20px;height: 186px;background-color: #FFFFFF;border-radius: 8px ">

        <div style="font-size: 20px;color: #000000;letter-spacing: 4px;white-space:nowrap;">用用户管理有什么好处？</div>
        <div style="height: 25px"></div>
        <div style="font-size: 14px;color: #999999;letter-spacing: 3px;">
          通常包括用户注册、登录、权限控制、角色管理 、用户个人资料管理等功能。

        </div>
      </div>


    </div>

    <div style="height: 150px"></div>


    <img style="width:236px;height:80px;margin-left: 80px" :src="u.config().static+'/'+system.logback">


    <div style="margin:80px;height: 3px;background-color: #999999"></div>

    <div style="height: 194px;padding:0 140px;display: flex;">
      <div style="width: 50%;display: flex">

        <div>
          <div><img style="width: 150px;height: 150px" :src="u.config().static+'/'+system.shop_code"></div>
          <div style="text-align: center;width: 150px">售前咨询</div>
        </div>
        <div style="margin-left: 40px">

          <div><img style="width: 150px;height: 150px;" :src="u.config().static+'/'+system.shop_code_no"></div>
          <div style="text-align: center;">售后咨询</div>

        </div>
        <div style="margin-left: 40px">
          <div><img style="width: 150px;height: 150px" :src="u.config().static+'/'+system.gongzhonghao"></div>
          <div style="text-align: center">微信公众号</div>
        </div>

      </div>

      <div style="text-align: right;width: 50%">

        <div style="margin-top: 30px">
          <a href="https://beian.miit.gov.cn/" target="_blank"
             style="        text-decoration:none;font-family: PingFang SC, PingFang SC;font-weight: 300;font-size: 24px;color: #333333;line-height: 28px;text-align: left;font-style: normal;text-transform: none;">{{ system.bottom_gongxing }}</a>
        </div>

        <a href="https://beian.miit.gov.cn/" target="_blank" style="display: none"> 蜀ICP备2023042080号-1</a>
        <div style="margin-top: 30px">

          <a data-v-3b456268="" href="https://beian.mps.gov.cn/#/query/webSearch?code=51012202001705" rel="noreferrer" target="_blank"
             style="font-weight: 300;text-decoration:none;font-size: 24px;color: #333333;line-height: 28px;text-align: left;font-style: normal;text-transform: none;">{{ system.bottom_gongan }}</a>
        </div>
      </div>
    </div>


    <el-dialog
      :show-close="false"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <div style="width: 772px;height: 462px;background-color: #fff">


        <div style="height: 193px;padding-left: 80px;overflow:hidden;text-overflow:ellipsis; white-space:nowrap; ;display: flex" class="hengfu">

          <img :src="u.config().static+'/homeadmin/image/henfangsunkangm.png'" style="width: 263px;height: 263px;">

          <div style="color: #FFFFFF">
            <div style="
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 24px;
            color: #FFFFFF;
            line-height: 16px;
            letter-spacing: 5px;
            padding:35px 0 ;
            text-align: left;
            font-style: normal;
            text-transform: none;
    ">现在咨询 您可获得:
            </div>

            <div style="
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 16px;
    letter-spacing: 3px;
    text-align: left;
    font-style: normal;
    text-transform: none;">
              <p>专业顾问一对一为您解答</p>
              <p>意向业务演示及介绍</p>
              <p>企业定制化解决方案</p>
            </div>


          </div>
        </div>

        <div style="padding:10px">

          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="公司名称">
              <el-input v-model="form.gongsi"></el-input>
            </el-form-item>

            <el-form-item label="联系人" required>
              <el-input v-model="form.user"></el-input>
            </el-form-item>
            <el-form-item label="联系方式" required>
              <el-input v-model="form.phone"></el-input>
            </el-form-item>

          </el-form>

        </div>
        <div style="text-align: center">
          <el-button style="width: 50%" type="primary" @click="sublitload">提交</el-button>
        </div>
      </div>


    </el-dialog>
    <img src="../../assets/image/zhuangshi01.png" style="position:absolute; right:-50px;top: 1189px;width: 244.86px">
    <img src="../../assets/image/zhuangshi02.png" style="position:absolute; left:10px;top: 1659px;width: 144.86px">
    <img src="../../assets/image/zhuangshi03.png" style="position:absolute; right:1px;top: 2659px;width: 144.86px">
    <img src="../../assets/image/zhuangshi04.png" style="position:absolute; left:1px;top: 2959px;width: 144.86px">

  </div>


</template>

<script>
import u from "../../assets/js/util"

var top = 0
export default {
  name: "index"
  ,
  data() {
    return {
      u,
      centerDialogVisible: false,
      isload: false,
      codemsg: "发送验证码",
      activeName: "first",
      checked: true,
      logintype: 1,
      desc: "",
      loginform: {
        phone: "",
        code: ""
      },
      form: {
        gongsi: "",
        pwd: "",
        user: "",
        phone: "",
      },
      system: {
        logback: "",
        bottom_gongxing: "",
        bottom_gongan: "",
        homeTitle: "",
        homeDesc: "",
        logindesc: "",
        indextitlemax: "",
        minsystemName: "",
        phonenumber: "",
        yonghuxieyi: "",
        yingsizhengce: "",
        shop_code_no: "",
        shop_code: "",
        gongzhonghao: "",
      },
    }
  },
  //页面加载完成执行

  async mounted() {

    var host = location.host
    var systeminfo = await u.get_no("admin", "getsysteminfo", host)
    if (systeminfo) {
      document.title = systeminfo.systemName
      this.system.homeDesc = systeminfo.homeDesc
      this.system.bottom_gongxing = systeminfo.bottom_gongxing
      this.system.bottom_gongan = systeminfo.bottom_gongan
      this.system.logindesc = systeminfo.logindesc
      this.system.homeTitle = systeminfo.homeTitle
      this.system.indextitlemax = systeminfo.indextitlemax
      this.system.minsystemName = systeminfo.minsystemName
      this.system.phonenumber = systeminfo.phonenumber
      this.system.yingsizhengce = systeminfo.yingsizhengce
      this.system.yonghuxieyi = systeminfo.yonghuxieyi
      this.system.logback = systeminfo.blucklogo[0]
      this.system.shop_code_no = systeminfo.shop_code_no[0]
      this.system.shop_code = systeminfo.shop_code[0]
      this.system.gongzhonghao = systeminfo.gongzhonghao[0]


    }

    var user = await u.post("users", "getuserinfo", {}, 1, 1, 1)
    if (user !== false) {
      window.userinfo = user
      // this.$router.push('/index')
    }
  },

  methods: {
    navrto(url) {
      window.open(url)
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    async login() {

      if (!this.checked) {

        var s = await this.$confirm('登录代表已经同意隐私政策和用户协议', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        if (s !== "confirm") {
          return
        }
        this.checked = true

      }

      if (!u.isPhone(this.loginform.phone)) {
        u.error("手机号格式不正确")
        return;
      }
      if (!this.loginform.code && this.logintype == 1) {
        u.error("验证码不能空")
        return;
      }

      if (!this.loginform.pwd && this.logintype == 2) {
        u.error("密码不能空")
        return;
      }
      var data = {}
      if (this.logintype == 2) {
        data = await u.post("users", "subpwdlogin", {phone: this.loginform.phone, pwd: this.loginform.pwd})
      } else {

        data = await u.post("users", u.config().loginfund, {phone: this.loginform.phone, code: this.loginform.code})
      }

      if (data !== false) {
        // document.cookie = "AUTH=" + data.auth+";expires="+(6000*60*24*30)
        setCookie("AUTH", data.auth, 60 * 60 * 24 * 30)
        window.userinfo = data.userinfo
        this.$router.push('/index')
      }
    },
    async get_code() {
      if (!u.isPhone(this.loginform.phone)) {
        u.error("手机号格式不正确")
        return;
      }

      if (this.codemsg != "发送验证码") {
        return
      }
      this.codemsg = 60
      var stl = setInterval(() => {
        this.codemsg = this.codemsg - 1

        if (this.codemsg <= 0) {
          this.codemsg = "发送验证码"
          clearInterval(stl)
        }
      }, 1000)
      var data = await u.post("users", "getcode_admin", {phone: this.loginform.phone, temp: "640013"})
      if (data === false) {
        u.error("获取失败")
        clearInterval(stl)
        this.codemsg = "发送验证码"
        return
      }
    },

    navtologin() {

      this.$router.push('/login')
    },
    sublitload() {
      if (this.isload) {
        u.error("您也提交信息 稍等工作人员联系您，请勿重复提交")
        return;
      }
      if (!u.isPhone(this.form.phone)) {
        u.error("电话格式不正确")
        return;
      }
      if (!this.form.user) {
        u.error("联系人不能空")
        return
      }
      if (!this.form.phone) {
        u.error("联系电话不能空")
        return
      }

      u.get_no("admin", "sublit", this.form)
      u.alert("提交成功，稍后工作人员联系您请留意电话")
      setTimeout(() => {
        this.form = {
          gongsi: "",
          user: "",
          phone: "",
          host: location.host,
        }
        this.centerDialogVisible = false
        this.isload = true
      }, 2000)
    }
  }

}

if (IsPhone()) {
  alert("目前只开放PC端， 是否继续访问")
  location.href = "https://h5.jlxz.shop/zigongsi/#/pages/login/login"

}

function IsPhone() {
//获取浏览器navigator对象的userAgent属性（浏览器用于HTTP请求的用户代理头的值）
  var info = navigator.userAgent;
//通过正则表达式的test方法判断是否包含“Mobile”字符串
  var isPhone = /mobile/i.test(info);
//如果包含“Mobile”（是手机设备）则返回true
  return isPhone;
}

function setCookie(name, val, min) {
  var now = new Date();
  //设置时间
  now.setMinutes(now.getMinutes() + min)

  //设置Cookie
  document.cookie = name + '=' + val + ';expires=' + now.toUTCString()
}
</script>

<style scoped>


.homeindex {
  margin: 0 auto;
  background-image: url("https://file.sumou.fun/homeadmin/image/homeback.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-evenly;
}

.homeindex .ovbacks {
  width: 50%;
}

.concent {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  user-select: none;
}

.concent::-webkit-scrollbar {
  display: none
}

.indexbox {
  width: 100%;
  height: 100%;
  background-image: url("https://file.sumou.fun/homeadmin/image/indexback.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.index_t3box {
  width: 505px;
  height: 554px;
  background: #FFFFFF;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
}

.index_t3box-title {

  width: 100%;
  height: 216px;
  background-image: url("https://file.sumou.fun/homeadmin/image/index_t3.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.index_t3box-_box_title {
  height: 48px;
  font-weight: 600;
  padding: 40px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-size: 36px;
  color: #FFFFFF;
  line-height: 42px;
}

.index_t3box-_box_txt {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 24px;
  color: #FFFFFF;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-left: 40px;
}

.nenglibox {
  width: 505px;
  height: 321px;
  background-image: url("https://file.sumou.fun/homeadmin/image/douying.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

}

.nenglibox-titl {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 36px;
  color: #FFFFFF;
  line-height: 42px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  padding: 40px;

}

.xieyi {
  color: #1190FF;
  cursor: pointer;
}

.nenglibox-desc {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #999999;
  line-height: 21px;
  padding: 40px;
  letter-spacing: 1px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  line-height: 30px;
}

.hezuoshang {

  height: 452px;
  background-image: url("https://file.sumou.fun/homeadmin/image/indext-t7.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.hengfu {
  margin-top: 200px;

  background-image: url("https://file.sumou.fun/homeadmin/image/zixunhengfu.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

/deep/ .el-dialog__header {
  padding: 0
}

/deep/ .el-dialog__footer {
  padding: 0
}

/deep/ .el-dialog__body {
  padding: 0
}

/deep/ .el-tabs__item:hover {
  color: #303133;
}

/deep/ .el-tabs__item.is-active {
  color: #303133;
}

/deep/ .el-dialog--center .el-dialog__body {
  padding: 0
}

@font-face {
  font-family: GraublauWeb;
  src: url("../../assets/font/font.otf");
}

.descname {
  font-family: GraublauWeb;
  color: #FF9C1B;
  font-size: 50px;
  letter-spacing: 7px;
  font-weight: 800;
}

.shouqian {

  background-image: url("https://file.sumou.fun/homeadmin/image/shouqianx.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}


</style>



// WEBPACK FOOTER //
// src/page/home/index.vue